import apiClient from './axiosConfig'; // Import the configured axios instance
import { API_ENDPOINTS } from '../constants'; // Import API_ENDPOINTS

const serviceApi = {
  getServices: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SERVICES}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },

  getServiceByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.SERVICES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching service ${identifier}:`, error);
      throw error;
    }
  },

  createService: async (serviceData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SERVICES}`, serviceData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating service:', error);
      throw error;
    }
  },

  updateService: async (identifier, serviceData) => {
    try {
      serviceData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.SERVICES}/${identifier}`, serviceData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating service:', error);
      throw error;
    }
  },

  trashService: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.SERVICES}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error('Error trashing service:', error);
      throw error;
    }
  },

  restoreService: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.SERVICES}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error('Error restoring service:', error);
      throw error;
    }
  },

  permanentDeleteService: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.SERVICES}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error('Error permanently deleting service:', error);
      throw error;
    }
  },
};

export default serviceApi;